define('presentation/settings/liveReceptionistScripts/facades/liveReceptionistScriptFindMeTabFacade',[
        'presentation/common/warningModal/presentationObjects/integrityWarningPresentationObject',
        'constants/referentialConstraintEnumerations'
    ],
    function() {
        const IntegrityWarningPresentationObjectConstructor = require('presentation/common/warningModal/presentationObjects/integrityWarningPresentationObject');

        const _liveReceptionistScriptSocket = require('externalDependencies/clientWebSocket').forApplication("liveReceptionistScript");
        const _integrityWarningMessagesEnumeration = require('constants/referentialConstraintEnumerations');
        let _promiseFactory = null;
        let _webSocketApp = null;


        const _deleteSchedule = (scheduleId, liveReceptionistScriptId) => {
            const request = {
                "accountAttendantScheduleId" : scheduleId
            };

            return _promiseFactory.defer((promise) => {
                _webSocketApp.send("delete", request, (result) => {
                    const parameters = {
                        liveReceptionistScriptId : liveReceptionistScriptId
                    };
                    _liveReceptionistScriptSocket.send("unassignLiveReceptionistScriptSchedule", parameters, (response) => {

                    });
                    promise.resolve();
                });
            });
        };

        const _getConstraints = (scheduleId) => {
            return _promiseFactory.defer((deferredObject) => {
                _webSocketApp.send("get_constraints", {accountAttendantScheduleId: scheduleId},  (constraints) => {
                    let integrityWarnings = [];
                    constraints.forEach((referencedObject) => {
                        if (_integrityWarningMessagesEnumeration[referencedObject.type]) {
                            const integrityWarning = new IntegrityWarningPresentationObjectConstructor();
                            integrityWarning.entityText = _integrityWarningMessagesEnumeration[referencedObject.type].entityText;
                            integrityWarning.entityName = referencedObject.name;
                            integrityWarning.icon = _integrityWarningMessagesEnumeration[referencedObject.type].icon;
                            integrityWarning.message = _integrityWarningMessagesEnumeration[referencedObject.type].message;
                            integrityWarnings.push(integrityWarning);
                        } else {
                            deferredObject.reject(new Error("Unhandled referenced object type."));
                        }
                    });
                    deferredObject.resolve(integrityWarnings);
                });
            });
        };

        const _init = (promiseFactory) => {
            _promiseFactory = promiseFactory;

            const WebSocketAppConstructor = require('persistence/webSocket/webSocketApp');
            _webSocketApp = new WebSocketAppConstructor();
            _webSocketApp.init("schedule_listing");
        };

        return function() {
            const self = this;
            self.init = _init;
            self.deleteSchedule = _deleteSchedule;
            self.getConstraints = _getConstraints;
        };
    });

